var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded bg-grad-2 d-flex align-items-center justify-content-center",style:({'min-width': _vm.width, 'min-height': _vm.height, 'height': _vm.height, 'width': _vm.width}),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('b-icon-file-earmark',{staticClass:"text-primary-design",attrs:{"scale":"3"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }